import { useEffect } from "react";

function getScrollTop() {
    return window.pageYOffset !== undefined
        ? window.pageYOffset
        : (
              document.documentElement ||
              document.body.parentNode ||
              document.body
          ).scrollTop;
}

export default function useSticky(arr) {
    useEffect(() => {
        const scrollFunction = () => {
            const scrollTop = getScrollTop();

            arr.forEach((e) => {
                if (e.type === "feedback-chrome") {
                    const headerMain = document.querySelector(".header-main");
                    const middleHeader = document.querySelector(".middle-header");
                    const nameRate = document.querySelector(".name-rate");
                    const navbar = document.querySelector(".navbar-main");
                    const navTab = document.querySelector(".nav-tab");
                    const progressBar = document.querySelector(".rating-step-progress");
                    const progressSlot = document.querySelector(
                        ".rating-step-progress-slot"
                    );

                    if (!headerMain || !middleHeader || !nameRate || !navbar || !navTab) {
                        return;
                    }

                    const compact = headerMain.classList.contains(
                        "header-main--compact"
                    );

                    let collapsed = false;
                    if (!compact) {
                        const bannerHeight = e.height ?? 180;
                        const minBanner = e.min ?? 0;
                        const currentBannerH = Math.max(
                            minBanner,
                            bannerHeight - scrollTop
                        );
                        middleHeader.style.height = `${currentBannerH}px`;
                        collapsed = currentBannerH <= minBanner;

                        if (collapsed) {
                            nameRate.style.position = "fixed";
                            nameRate.style.top = "0";
                            nameRate.style.bottom = "auto";
                            nameRate.style.left = "0";
                            nameRate.style.right = "0";
                            nameRate.style.padding = "8px 16px";
                            nameRate.style.zIndex = "20";
                            nameRate.style.backgroundColor = "#fff";
                            nameRate.style.boxShadow = "0 1px 3px rgba(0,0,0,.08)";
                            nameRate.style.margin = "0";

                            middleHeader.style.overflow = "visible";
                        } else {
                            nameRate.style.position = "";
                            nameRate.style.top = "";
                            nameRate.style.bottom = "";
                            nameRate.style.left = "";
                            nameRate.style.right = "";
                            nameRate.style.padding = "";
                            nameRate.style.zIndex = "";
                            nameRate.style.backgroundColor = "";
                            nameRate.style.boxShadow = "";
                            nameRate.style.margin = "";

                            middleHeader.style.overflow = "";
                        }
                    }

                    const nameRateRect = compact
                        ? middleHeader.getBoundingClientRect()
                        : nameRate.getBoundingClientRect();
                    const nameRateBottom = nameRateRect.bottom;

                    const navTabTop = navTab.getBoundingClientRect().top;
                    const shouldStickNav = collapsed || navTabTop <= nameRateBottom;

                    if (shouldStickNav) {
                        navbar.style.position = "fixed";
                        navbar.style.top = `${nameRateBottom}px`;
                        navbar.style.left = "0";
                        navbar.style.right = "0";
                        navbar.style.backgroundColor = "#fff";
                        navbar.style.boxShadow = "0 2px 6px rgba(0,0,0,.08)";
                        navbar.style.zIndex = "19";
                        navbar.classList.add("is-stuck");
                    } else {
                        navbar.style.position = "";
                        navbar.style.top = "";
                        navbar.style.left = "";
                        navbar.style.right = "";
                        navbar.style.backgroundColor = "";
                        navbar.style.boxShadow = "";
                        navbar.style.zIndex = "";
                        navbar.classList.remove("is-stuck");
                    }

                    if (progressBar && progressSlot) {
                        const navbarRect = navbar.getBoundingClientRect();
                        const chromeBottom = shouldStickNav
                            ? navbarRect.bottom
                            : Math.max(nameRateBottom, navbarRect.bottom);
                        const slotTop = progressSlot.getBoundingClientRect().top;
                        const shouldStickProgress = slotTop <= chromeBottom + 0.5;
                        const wasStuck = progressBar.classList.contains("is-stuck");

                        if (shouldStickProgress) {
                            if (!wasStuck) {
                                progressSlot.style.height = `${progressBar.getBoundingClientRect().height}px`;
                                progressBar.classList.add("is-stuck");
                            }
                            progressBar.style.top = `${Math.max(0, chromeBottom)}px`;
                        } else if (wasStuck) {
                            progressSlot.style.height = "";
                            progressBar.classList.remove("is-stuck");
                            progressBar.style.top = "";
                        }
                    } else if (progressBar) {
                        progressBar.classList.remove("is-stuck");
                        progressBar.style.top = "";
                    }

                    return;
                }

                if (e.type === "height") {
                    const el = document.querySelector(e.query);
                    if (!el) return;
                    if (e.min < e.height - scrollTop) {
                        el.style.height = e.height - scrollTop + "px";
                    } else {
                        el.style.height = e.min + "px";
                    }
                }

                if (e.type === "top") {
                    const el = document.querySelector(e.query);
                    const reference = document.querySelector(e.reference);
                    const target = document.querySelector(e.target);
                    if (!el || !reference || !target) return;

                    if (e.min != null) {
                        el.style.top = e.min - scrollTop + "px";
                    }

                    const referencePos = reference.getBoundingClientRect();
                    const targetPos = target.getBoundingClientRect();

                    if (
                        referencePos.top <=
                        targetPos.top + targetPos.height + (e.offset || 0)
                    ) {
                        el.style.top =
                            targetPos.top +
                            targetPos.height +
                            (e.offset || 0) +
                            "px";
                        el.style.position = "fixed";
                        el.style.backgroundColor = "white";
                        el.style.boxShadow = "0 4px 5px rgba(0,0,0,.1)";
                    } else {
                        el.style.position = "static";
                        el.style.top = null;
                        el.style.backgroundColor = "transparent";
                        el.style.boxShadow = "none";
                    }
                }
            });
        };

        window.addEventListener("scroll", scrollFunction, true);
        document.addEventListener("touchmove", scrollFunction, true);
        window.addEventListener("resize", scrollFunction);
        window.addEventListener("feedback-chrome-reflow", scrollFunction);
        scrollFunction();
        return () => {
            window.removeEventListener("scroll", scrollFunction, true);
            document.removeEventListener("touchmove", scrollFunction, true);
            window.removeEventListener("resize", scrollFunction);
            window.removeEventListener("feedback-chrome-reflow", scrollFunction);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
